import React from "react";

import { useHistory, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";

import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";

import MuiDrawer from "@mui/material/Drawer";
import PersonIcon from "@mui/icons-material/Person";
import AssessmentIcon from "@mui/icons-material/Assessment";
import HomeIcon from "@mui/icons-material/Home";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  marginTop: "64px",
  //padding: "10px",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  marginTop: "64px",
  //padding: "10px",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  marginTop: "64px",
  //padding: "10px",

  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function MiniDrawer({ open, ...props }) {
  let history = useHistory();
  const location = useLocation();

  let level = parseInt(localStorage.getItem("user_level"), 10);

  const onMenuItemClick = (path) => {
    history.push(path);
  };

  const isDrawerVisible = (location) => {
    const hiddenPaths = [
      "/",
      "/login",
      "/logout",
      "/verify",
      "/forgot",
      "/resetpassword",
      "/mfa",
      "/observation-tablet-chart",
    ];
    return !hiddenPaths.includes(location.pathname);
  };

  const menuItems = [
    { path: "/home", icon: <HomeIcon />, text: "Home" },
    { path: "/users", icon: <PersonIcon />, text: "Users" },
    { path: "/logs", icon: <ManageSearchIcon />, text: "Audit logs" },
    { path: "/reports", icon: <AssessmentIcon />, text: "Reports" },
    // { path: "/formsscreen", icon: <AssessmentIcon />, text: "Forms" },
  ];

  return (
    <>
      {isDrawerVisible(location) && (
        <Drawer variant="permanent" open={open}>
          <List>
            {menuItems.map((item) => {
              if (level >= 1 && level <= 6) {
                return (
                  <ListItem
                    key={item.path}
                    button
                    onClick={() => onMenuItemClick(item.path)}
                    data-test={`menu-item-${item.path.substring(1)}`}
                  >
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText primary={item.text} />
                  </ListItem>
                );
              } else if (item.path === "/home") {
                return (
                  <ListItem
                    key={item.path}
                    button
                    onClick={() => onMenuItemClick(item.path)}
                    data-test={`menu-item-${item.path.substring(1)}`}
                  >
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText primary={item.text} />
                  </ListItem>
                );
              }
              return null;
            })}
          </List>
        </Drawer>
      )}
    </>
  );
}
